import { useTranslation } from "react-i18next";

import { useCreate } from "@/hooks/queries";

import OrganizationForm from "./OrganizationForm";

const Create = () => {
  const { t } = useTranslation();

  const mutation = useCreate("organizations");
  const saveButtonLabel = t("global:add");
  const initialValues = { name: "", description: "", address: "" };

  return (
    <OrganizationForm
      mutation={mutation}
      saveButtonLabel={saveButtonLabel}
      initialValues={initialValues}
    />
  );
};

export default Create;
